module.exports = __webpack_public_path__ + "img/BusinessCard.69c12603.jpg";